<template>
  <div class="ui form">
    <div class="two fields">
      <div class="field">
        <label for="">{{ $t("invited role") }}</label>
        <div class="ui selection dropdown" ref="user_dropdown">
          <input type="hidden" name="ddwn" />
          <i class="dropdown icon"></i>
          <div class="default text"></div>
          <div class="menu"></div>
        </div>
      </div>
      <div class="field">
        <label for="">{{ $t("set user permissions") }} </label>
        <div class="ui toggle checkbox">
          <input
            type="checkbox"
            name="public"
            v-model="setup.export_only_own_records"
          />
          <label>{{ $t("limited to export only own records") }}</label>
        </div>
        <div class="ui toggle checkbox">
          <input
            type="checkbox"
            name="public"
            v-model="setup.edit_only_own_records"
          />
          <label>{{ $t("limited to edit only own records") }}</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { local_api, error_toast } from "@/utils";

export default {
  name: "ArqueologyConfigurationModal_Security",
  data() {
    return {
      setup: {
        invited_role_id: undefined,
        export_only_own_records: undefined,
        edit_only_own_records: undefined,
      },
    };
  },
  mounted() {
    let vm = this;
    local_api(vm, "post", "/user_role/do-get-all")
      .then((r) => {
        let vls = r.map((_r) => {
          return { value: _r.role_id, name: _r.name };
        });
        vls.unshift({ value: "", name: vm.$t("none") });
        window
          .jQuery(vm.$refs.user_dropdown)
          .dropdown("setup menu", { values: vls })
          .dropdown({
            onChange(value) {
              vm.setup.invited_role_id = value;
            },
          });
      })
      .catch((err) => {
        error_toast(err);
      });
  },
  methods: {
    getData() {
      return this.setup;
    },
    setData(data) {
      let vm = this;
      vm.setup = data;

      console.log(data.invited_role_id);
      if (data.invited_role_id) {
        setTimeout(() => {
          window
            .jQuery(vm.$refs.user_dropdown)
            .dropdown("set selected", data.invited_role_id);
        }, 100);
      }
    },
  },
};
</script>

<style scoped>
div.toggle.checkbox {
  margin: 10px 0 !important;
}
</style>
